export const data2_1 = [{
    name: '',
    name_code: "",
    Jan: "1",
    Feb: "1",
    Mar: "1",
    Apr: "1",
    May: "1",
    Jun: "1",
    Jul: "1",
    Aug: '1',
    Sep: "1",
    Oct: "1",
    Nov: "1",
    Dec: "1",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Café/All Day Dinning 西餐厅',
    name_code: "Café/All_Day_Dinning",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Rooms Sold 出租房间',
    name_code: "Rooms_Sold",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Double Occupancy Rate 双人入住率',
    name_code: "Double_Occupancy_Rate",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'No. of In-house Guest 住店客人人数',
    name_code: "No._of_In-house_Guest",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'In-house Capture Ratio % 住店客人用餐率',
    name_code: "In-house_Capture_Ratio",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Actual Breakfast Covers 实际用早餐人数',
    name_code: "Actual_Breakfast_Covers",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Breakfast Allocation 单份早餐配给金额',
    name_code: "Breakfast_Allocation",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Breakfast Total Allocation to F&B 早餐划归餐饮部金额',
    name_code: "Breakfast_Total_Allocation_to_F&B",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Breakfast F&B Cost 早餐食品及饮料成本',
    name_code: "Breakfast_F&B_Cost",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Breakfast F&B Cost % 早餐食品饮料成本率',
    name_code: "Breakfast_F&B_Cost",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Breakfast Net Income 早餐收入',
    name_code: "Breakfast_Net_Income",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Club Lounge 行政酒廊',
    name_code: "Club_Lounge",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Club & Suites Available 行政楼及套房可出租数',
    name_code: "Club_Suites_Available",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Club & Suites Sold 行政楼及套房实际出租数',
    name_code: "Club_Suites_Sold",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Club & Suites No. of Guest 行政楼及套房客人数',
    name_code: "Club_Suites_No_of_Guest",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Club & Suites Double Occ Rate 行政楼及套房双人入住率',
    name_code: "Club_&_Suites_Double_Occ_Rate",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Club & Suites Occupancy 行政楼及套房入住率',
    name_code: "Club_Suites_Occupancy",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Club & Suites ADR 行政楼及套房平均房价',
    name_code: "Club_&_Suites_ADR",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Club & Suites Room Revenue 行政楼及套房客房收入',
    name_code: "Club_&_Suites_Room_Revenue",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Cost of Breakfast at Club Lounge 早餐食品饮料成本划分总金额',
    name_code: "Cost_of_Breakfast_at_Club_Lounge",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Afternoon Tea & Evening Cocktail Cost 下午茶及欢乐时光成本',
    name_code: "Afternoon_Tea_&_Evening_Cocktail_Cost",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Club & Suites F&B Total Cost',
    name_code: "Club_Suites_F&B_Total_Cost",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Club & Suites F&B Cost Per Room',
    name_code: "Club_&_Suites_F&B_Cost_Per_Room",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}, {
    name: 'Club & Suites Net Room Income 行政楼及套房净客房收入',
    name_code: "Club_&_Suites_Net_Room_Income",
    Jan: "0",
    Feb: "0",
    Mar: "0",
    Apr: "0",
    May: "0",
    Jun: "0",
    Jul: "0",
    Aug: '0',
    Sep: "0",
    Oct: "0",
    Nov: "0",
    Dec: "0",
    whole: "0",
    last: "0",
    variance: "0",
}]


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-5/data.js